// RTL languages list
const RTL_LANGUAGES = ['ar', 'he', 'fa', 'ur'];

// Detect language from multiple sources with priority
export const detectLanguage = () => {
  // Priority 1: localStorage (user's previous choice)
  const savedLanguage = localStorage.getItem('user_language');
  if (savedLanguage) {
    return savedLanguage;
  }

  // Priority 2: Browser language
  const browserLang = navigator.language || navigator.userLanguage;
  const langCode = browserLang.split('-')[0]; // 'en-US' -> 'en'
  
  // Check if we support this language
  const supportedLanguages = ['en', 'fr', 'ar'];
  if (supportedLanguages.includes(langCode)) {
    return langCode;
  }

  // Priority 3: Default fallback
  return 'en';
};

export const saveLanguage = (language) => {
  localStorage.setItem('user_language', language);
};

// Check if a language is RTL (Right-to-Left)
export const isRTLLanguage = (lang) => {
  return RTL_LANGUAGES.includes(lang);
};

// Get text direction for a given language
export const getDirectionForLanguage = (lang) => {
  return isRTLLanguage(lang) ? 'rtl' : 'ltr';
};

// Future: This function will be replaced/enhanced with API call
export const getUserLanguageFromAPI = async (userProfile) => {
  // Placeholder for future backend integration
  // When backend provides user.language:
  // return userProfile.language || detectLanguage();
  return null; // Currently not available
};
